import { apiRequest } from '@/utils/api-request';

export interface WorkflowInputField {
  node_instance_id: string;
  node_display_name: string;
  field_id: string;
  display_name: string;
  valid_types: string[];
  current_value: unknown;
  required: boolean;
  options: unknown[] | null;
  min_value: number | null;
  max_value: number | null;
  description: string | null;
}

export interface WorkflowInputsResponse {
  version_id: string;
  inputs: WorkflowInputField[];
}

export async function getWorkflowInputs(
  orgId: string,
  workflowId: string,
): Promise<WorkflowInputsResponse> {
  const response = await apiRequest<WorkflowInputsResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/inputs`,
    method: 'GET',
    target: 'workflow',
  });
  if (response.detail || response.success === false || !response.data) {
    throw new Error(response.detail || 'Failed to load workflow inputs');
  }
  return response.data;
}
